import React from "react";
import Header from "../Components/Header";
import Footer from "../Components/Footer";
import PageHeader from "../Components/Pageheader";
import {
  contact1,
  contact2,
  contact3,
  contactimg,
  dot,
} from "../Constant/Index";
import { Button, Form } from "antd";
import Input from "antd/es/input/Input";
import TextArea from "antd/es/input/TextArea";
import "../assets/Css/contact.css";
import { Link } from "react-router-dom";

function Contactus() {
  return (
    <>
      <Header />
      <PageHeader pagename="Contact Us" />

      {/* Contact US Section  */}
      <section className="contact-sec">
        <div className="container">
          <div className="row">
            <div className="col-md-6 ">
              <div className="contact-img">
                <img
                  src={contactimg}
                  className="img-fluid"
                  alt="contact-image"
                />
              </div>
            </div>
            <div className="col-md-6">
              <div className="contact-head">
                <h3 className="primary-color">Get In Touch</h3>
                <p className="primary-color">
                  Welcome to Powerful Hand, your multi-lingual E-Commerce
                  destination for ritual and spiritual products. From candles to
                  sacred herbs, we offer a diverse range catering to global
                  practices.
                </p>
              </div>
              <div className="contact-form">
                <Form>
                  <div className="row">
                    <div className="col-md-6">
                      <div className="input-dv">
                        <label className="primary-color">First Name</label>
                        <Input type="text" placeholder="Enter First Name" />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="input-dv">
                        <label className="primary-color">Last Name</label>

                        <Input type="text" placeholder="Enter Last Name" />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="input-dv">
                        <label className="primary-color">Last Name</label>

                        <Input type="email" placeholder="Email Address" />
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="input-dv">
                        <label className="primary-color">Contact Number</label>

                        <Input type="number" placeholder="Number" />
                      </div>
                    </div>
                    <div className="col-md-12">
                      <div className="input-dv">
                        <label className="primary-color">Message</label>
                        <TextArea placeholder="Message" />
                      </div>
                    </div>
                    <div className="col-md-12">
                      <div className="contact-btn">
                        <Button
                          type="primary"
                          htmlType="submit"
                          className="bg-gradient btn__submit mt-2 primary-bg"
                        >
                          Submit
                        </Button>
                      </div>
                    </div>
                  </div>
                </Form>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* ================== */}

      {/* Contact Section two  */}
      <section className="contact-sec-two">
        <div className="container">
          <div className="row">
            <div className="col-md-6">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d46830151.11795828!2d-119.8093025!3d44.24236485!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x54eab584e432360b%3A0x1c3bb99243deb742!2sUnited%20States!5e0!3m2!1sen!2s!4v1716471654125!5m2!1sen!2s"
                width="534"
                height="450"
              ></iframe>
            </div>

            <div className="col-md-6 border-left">
              <div className="brix-ton">
                <div className="brix-ton-head">
                  <h3 className="primary-color">Brixton Store</h3>
                </div>
                <div className="row">
                  <div className="col-md-12">
                    <div className="contact-dv">
                      <div className="contact-info">
                        <h4 className="primary-color">
                          <span>
                            <img src={dot} className="img-fluid" alt="" />
                          </span>{" "}
                          phone number
                        </h4>
                        <Link className="primary-color">020 7738 3769</Link>{" "}
                        <br />
                        <Link className="primary-color">078530 45785</Link>
                      </div>
                      <div className="contact-phone">
                        <span>
                          <img
                            src={contact2}
                            className="img-fluid"
                            alt="phone"
                          />
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-12 border-top border-bottom">
                    <div className="contact-dv">
                      <div className="contact-info">
                        <h4 className="primary-color">
                          <span>
                            <img src={dot} className="img-fluid" alt="" />
                          </span>{" "}
                          Email Address
                        </h4>
                        <Link className="primary-color">
                          brixton@powerfulhand.com
                        </Link>{" "}
                        <br />
                        <Link className="primary-color">
                          contact@powerfulhand.com
                        </Link>
                      </div>
                      <div className="contact-phone">
                        <span>
                          <img
                            src={contact1}
                            className="img-fluid"
                            alt="phone"
                          />
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-12">
                    <div className="contact-dv">
                      <div className="contact-info">
                        <h4 className="primary-color">
                          <span>
                            <img src={dot} className="img-fluid" alt="" />
                          </span>{" "}
                          Location
                        </h4>
                        <p className="primary-color">
                          15 Electric Lane, Brixton, SW9 8LA, London, England.
                        </p>
                      </div>
                      <div className="contact-phone">
                        <span>
                          <img
                            src={contact3}
                            className="img-fluid"
                            alt="phone"
                          />
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* ====================== */}

       {/* Contact Section Three  */}
      <section className="contact-sec-three">
      <div className="container">
          <div className="row">
            

            <div className="col-md-6 border-right">
              <div className="brix-ton">
                <div className="brix-ton-head">
                  <h3 className="primary-color">Birmingham Store</h3>
                </div>
                <div className="row">
                  <div className="col-md-12">
                    <div className="contact-dv">
                      <div className="contact-info">
                        <h4 className="primary-color">
                          <span>
                            <img src={dot} className="img-fluid" alt="" />
                          </span>{" "}
                          phone number
                        </h4>
                        <Link className="primary-color">020 7738 3769</Link>{" "}
                        <br />
                        <Link className="primary-color">078530 45785</Link>
                      </div>
                      <div className="contact-phone">
                        <span>
                          <img
                            src={contact2}
                            className="img-fluid"
                            alt="phone"
                          />
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-12 border-top border-bottom">
                    <div className="contact-dv">
                      <div className="contact-info">
                        <h4 className="primary-color">
                          <span>
                            <img src={dot} className="img-fluid" alt="" />
                          </span>{" "}
                          Email Address
                        </h4>
                        <Link className="primary-color">
                          brixton@powerfulhand.com
                        </Link>{" "}
                        <br />
                        <Link className="primary-color">
                          contact@powerfulhand.com
                        </Link>
                      </div>
                      <div className="contact-phone">
                        <span>
                          <img
                            src={contact1}
                            className="img-fluid"
                            alt="phone"
                          />
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-12">
                    <div className="contact-dv">
                      <div className="contact-info">
                        <h4 className="primary-color">
                          <span>
                            <img src={dot} className="img-fluid" alt="" />
                          </span>{" "}
                          Location
                        </h4>
                        <p className="primary-color">
                          15 Electric Lane, Brixton, SW9 8LA, London, England.
                        </p>
                      </div>
                      <div className="contact-phone">
                        <span>
                          <img
                            src={contact3}
                            className="img-fluid"
                            alt="phone"
                          />
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-md-6 ">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d46830151.11795828!2d-119.8093025!3d44.24236485!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x54eab584e432360b%3A0x1c3bb99243deb742!2sUnited%20States!5e0!3m2!1sen!2s!4v1716471654125!5m2!1sen!2s"
                width="534"
                height="450"
              ></iframe>
            </div>
          </div>
        </div>


      </section>

      <Footer />
    </>
  );
}

export default Contactus;
